import * as generated from './generated/tokens.generated';
// ─── Values ──────────────────────────────────────────────────────────────
// Every literal below comes from `apps/web/design-system/tokens/tokens.css` via the
// generated module (WEB-999). Edit the token there and run
// `pnpm --filter web tokens:generate` — never add a literal here.
export const spacingScale = generated.spacingScale;
export const semanticSpacing = {
    xs: spacingScale.xs,
    sm: spacingScale.sm,
    md: spacingScale.md,
    lg: spacingScale.lg,
    xl: spacingScale.xl,
    '2xl': spacingScale['2xl'],
};
export const borderRadiusScale = generated.borderRadiusScale;
export const shadowScale = generated.shadowScale;
export const darkShadowScale = generated.darkShadowScale;
export const breakpoints = generated.breakpoints;
export const typographyScale = generated.typographyScale;
// Loci palette — DS v1.1.0 (WEB-332).
// brand.primary = Electric Amber retained as the **national accent** for
//   cross-city CTAs only (footer mark, national share). It is no longer the
//   page-dominant CTA color on CLT surfaces — that role moves to
//   `city.clt.skyline` per `docs/design-system/1.1.0/colors_and_type.css`.
// accent.primary = Loci Indigo (the theme-invariant typographic foundation).
// city.clt      = CLT (Charlotte) per-city colorway — Skyline Blue + Ember.
export const brandColors = generated.brandColors;
// National brand tokens (WEB-178) — named to match
// docs/design-system/1.0.0/tokens/colors_and_type.css and consumed by the
// [data-layer="apex"] overlay. Kept aligned with `brandColors.brand` so a
// single hex change propagates to every consumer.
export const lociAmber = brandColors.brand.primary;
export const lociAmberLight = brandColors.brand.light;
export const lociIndigo = brandColors.accent.primary;
// Glass-pill tokens (WEB-178) — back the inline city picker on apex (WEB-182)
// and any future glass surface needing the strong backdrop variant. Values
// mirror the apex template's `--glass-bg-strong` / `--glass-border-strong`
// definitions so JS consumers and the CSS overlay stay in lockstep.
export const glassBgStrong = generated.glassBgStrong;
export const glassBorderStrong = generated.glassBorderStrong;
// Amber focus-ring shadow (WEB-178) — paired with `lociAmber` for focus
// states on apex surfaces. Shape matches the existing `--shadow-ring-teal`
// token in apps/web/styles/tokens/shadow.css for consistency across layer accents.
export const shadowRingAmber = generated.shadowRingAmber;
// WCAG AA compliant category palette (4.5:1 minimum contrast ratio).
// subtle variant:  bg=light / text=dark      (all pairs ≥7:1)
// filled variant:  bg=primary / text=primaryFg (all pairs ≥4.5:1)
// outlined variant: text=primary on page bg  (light: white ≥4.5:1 / dark: #0a0a0f ≥4.5:1)
//
// Light and dark palettes differ because the outlined variant places primary-colored text on opposite
// backgrounds (white vs. #0a0a0f), requiring lighter primaries in dark mode — which in turn need a
// dark primaryFg for the filled variant instead of white.
export const categoryColorsLight = generated.categoryColorsLight;
// Dark mode uses lighter primaries so text is legible on the dark (#0a0a0f) page background.
// primaryFg switches to a deep shade to maintain contrast on the now-lighter filled background.
export const categoryColorsDark = generated.categoryColorsDark;
/** @deprecated Use categoryColorsLight or categoryColorsDark based on theme mode */
export const categoryColors = categoryColorsLight;
// Neighborhood palette — distinct from category colors so geographic identity
// stays separable from event taxonomy. Values meet WCAG AA against the light
// and dark surface backgrounds when used for the AffinityRing stroke.
// Primaries are unique across the 23-neighborhood set (PIP-178) so cards stay
// visually separable on the marketing /neighborhoods grid. None collide with
// the CLT skyline-glow accent (#4FC4C4) — Uptown owns the deeper teal slot.
export const neighborhoodColorsLight = generated.neighborhoodColorsLight;
// Dark mode lifts each primary so the ring stroke stays legible against the
// deep surface background.
export const neighborhoodColorsDark = generated.neighborhoodColorsDark;
export const neutralScale = generated.neutralScale;
// DS v1.1.0 (WEB-332) — CLT Skyline Teal CTA over Loci Indigo typography.
// primary / accent / ring all resolve to CLT Skyline so per-page dominant
// brand color reads as `#0E7B7B` on CLT surfaces. Electric Amber is retained
// as the **national** accent (`brandColors.brand.primary`) for cross-city
// CTAs only, and surfaces the AA-darkened `#CC9300` via the `warning` slot
// where amber-on-surface is by-design (e.g. status badges).
// Source: docs/design-system/1.1.0/colors_and_type.css.
export const semanticLight = generated.semanticLight;
export const semanticDark = generated.semanticDark;
export const lightThemeTokens = {
    mode: 'light',
    colors: semanticLight,
    category: categoryColorsLight,
    neighborhood: neighborhoodColorsLight,
    neutral: neutralScale,
    spacing: spacingScale,
    semanticSpacing,
    borderRadius: borderRadiusScale,
    typography: typographyScale,
    shadows: shadowScale,
    breakpoints,
};
export const darkThemeTokens = {
    mode: 'dark',
    colors: semanticDark,
    category: categoryColorsDark,
    neighborhood: neighborhoodColorsDark,
    neutral: neutralScale,
    spacing: spacingScale,
    semanticSpacing,
    borderRadius: borderRadiusScale,
    typography: typographyScale,
    shadows: darkShadowScale,
    breakpoints,
};
export const themeModes = {
    light: lightThemeTokens,
    dark: darkThemeTokens,
};
